import _extends from "@babel/runtime/helpers/extends";
import { Box, xcss } from '@atlaskit/primitives';
import React from 'react';
import { charlieTextFontFamily } from '../../../FontFamily';
import { ErrorState } from './ErrorState';
import { LoadingSpinner } from './LoadingSpinner';
/**
 *  Separate `Internal` component created for the custom UI, to make it easier to test.
 * `CustomMenu` is passed to react select, and requires additional props that are
 * internally used by react select, so is difficult to test.
 */
export const CustomMenuInternal = _ref => {
  let {
    status,
    children
  } = _ref;
  if (status === 'error') {
    return /*#__PURE__*/React.createElement(ErrorState, null);
  }
  if (status === 'loading') {
    return /*#__PURE__*/React.createElement(LoadingSpinner, null);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};
const customMenuStyles = xcss(charlieTextFontFamily);
export const CustomMenu = _ref2 => {
  let {
    innerRef,
    innerProps,
    selectProps: {
      status
    },
    children
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: innerRef
  }, innerProps), /*#__PURE__*/React.createElement(Box, {
    xcss: customMenuStyles
  }, /*#__PURE__*/React.createElement(CustomMenuInternal, {
    status: status
  }, children)));
};